import { base64ResumeToArrayBuffer } from 'modules/hiring/utilities';

const DOCX_MIME =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const isHttpUrl = (value: string): boolean =>
  /^https?:\/\//i.test(value);

export const getResumeBlob = async (
  docLink: string,
  rawResume?: string,
): Promise<Blob> => {
  if (isHttpUrl(docLink)) {
    const response = await fetch(docLink);
    if (!response.ok) {
      throw new Error(`Failed to load resume (${response.status})`);
    }
    return response.blob();
  }

  const buffer =
    base64ResumeToArrayBuffer(docLink) ?? base64ResumeToArrayBuffer(rawResume);
  if (!buffer) {
    throw new Error('Invalid resume data');
  }

  return new Blob([buffer], { type: DOCX_MIME });
};
